/* SantoLoco: one-tap size add-to-cart + hero slider */
(function () {
  if (window.__slInit) return;
  window.__slInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function toast(msg) {
    var t = document.getElementById('sl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sl-toast';
      t.className = 'sl-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    var a = document.createElement('a');
    a.href = root + 'cart';
    a.textContent = 'View cart →';
    t.appendChild(span);
    t.appendChild(a);
    t.hidden = false;
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.hidden = true; }, 5000);
  }

  // Tell the theme about the add the same way Horizon's own buttons do (Shopify standard cart event),
  // so the cart icon, the cart drawer and the complete-the-look offer all update.
  var evMod = null;
  function stdEvents() {
    if (!evMod) evMod = import('@shopify/events')
      .catch(function () { return import('https://cdn.shopify.com/storefront/standard-events.js'); })
      .catch(function () { return null; });
    return evMod;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sl-add][data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    var label = btn.getAttribute('data-label') || '';
    var title = btn.getAttribute('data-title') || 'Item';
    var src = btn.closest('[data-sl-pair]') ? 'sl-pair' : 'sl-quick-size';
    btn.disabled = true;
    if (src === 'sl-pair') window.__slOfferAdd = true;   // the offer's own buttons shouldn't re-trigger it
    stdEvents().then(function (m) {
      var def = null, Ev = m && m.CartLinesUpdateEvent;
      if (Ev && Ev.createPromise) {
        try {
          def = Ev.createPromise();
          btn.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: def.promise }));
        } catch (err) { def = null; }
      }
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (def) def.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: src, sourceId: src, variantId: id, itemCount: 1, didError: !res.ok } });
              document.querySelectorAll('[data-sl-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            })
            .catch(function (err) { if (def) def.reject(err); });
          window.__slOfferAdd = false;
          if (src === 'sl-pair' && res.ok && window.slPairDone) window.slPairDone();
          if (!res.ok) { toast(res.j && res.j.description ? res.j.description : 'Sorry, that size just sold out.'); return; }
          btn.classList.add('is-added');
          var oldText = btn.textContent;
          if (btn.classList.contains('sl-card__cta')) btn.textContent = 'Added ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = oldText; }, 1800);
          toast('Added: ' + title + (label ? ' · ' + label : ''));
        });
    }).catch(function () {
      btn.disabled = false;
      window.__slOfferAdd = false;
      window.location.href = root + 'cart/add?id=' + id + '&quantity=1';
    });
  });

  // Cart safety net: if a tap on the trash can hasn't started removing the line after 1.5s,
  // remove that exact line ourselves (by its line key) and refresh the cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-items__remove');
    if (!btn) return;
    var row = btn.closest('[data-key]');
    if (!row || !row.dataset.key) return;
    var key = row.dataset.key;
    setTimeout(function () {
      if (!row.isConnected || row.classList.contains('removing')) return;   // the theme handled it
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return stdEvents().then(function (m) {
            var Ev = m && m.CartLinesUpdateEvent;
            if (!Ev || !Ev.createPromise) { window.location.reload(); return; }
            var def = Ev.createPromise();
            document.dispatchEvent(new Ev({ action: 'remove', context: 'cart', lines: [{ id: key, quantity: 0 }], promise: def.promise }));
            def.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: cart.item_count, source: 'sl-cart-fallback', didError: false } });
            row.remove();
          });
        })
        .catch(function () { window.location.reload(); });
    }, 1500);
  }, true);

  function initHero(el) {
    if (el.__sl) return;
    el.__sl = true;
    var track = el.querySelector('.sl-hero__track');
    var slides = el.querySelectorAll('.sl-hero__slide');
    var dots = el.querySelectorAll('.sl-hero__dot');
    if (slides.length < 2) return;
    var i = 0;
    var delay = Number(el.getAttribute('data-autoplay') || 0) * 1000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); s.querySelectorAll('a').forEach(function (a) { a.tabIndex = k === i ? 0 : -1; }); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
    var prev = el.querySelector('[data-sl-prev]');
    var next = el.querySelector('[data-sl-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      x0 = null;
    });
    var timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function restart() {
      if (timer) clearInterval(timer);
      if (delay > 0 && !reduce) timer = setInterval(function () { go(i + 1); }, delay);
    }
    el.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    el.addEventListener('mouseleave', restart);
    go(0);
    restart();
  }

  function initAll() { document.querySelectorAll('[data-sl-hero]').forEach(initHero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
